module.exports = __webpack_public_path__ + "static/media/menu02.0f6ebb68.svg";